var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E81313"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6433 44.9828C25.607 43.6246 25.1005 41.9356 25.2185 40.2313C25.3364 38.527 26.0708 36.9239 27.2843 35.7214C34.3219 28.723 45.7416 28.7549 52.74 35.7925C53.9469 37.0017 54.6722 38.6089 54.7807 40.3138C54.8891 42.0188 54.3732 43.7049 53.3294 45.0573C53.0625 45.3964 52.6932 45.6401 52.2765 45.752C51.8597 45.864 51.418 45.8381 51.0171 45.6784L44.9893 43.3608L44.9787 43.3502C44.6719 43.2279 44.4001 43.0315 44.1877 42.7786C43.9752 42.5257 43.8287 42.2241 43.7613 41.9007C43.7534 41.8609 43.7482 41.822 43.7439 41.7822L43.414 37.7596C41.4086 37.0708 38.6066 37.0753 36.578 37.7688L36.246 41.7498C36.2425 41.7887 36.2368 41.8273 36.2289 41.8655C36.1628 42.1914 36.0166 42.4957 35.8033 42.7508C35.5901 43.0059 35.3167 43.2039 35.0077 43.3267L34.9909 43.3329L28.9546 45.6141C28.5528 45.7726 28.1106 45.7967 27.6939 45.6829C27.2773 45.5691 26.9087 45.3235 26.6433 44.9828Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutCall);
export default __webpack_public_path__ + "static/media/CutCall.0a7f828446eba909fc5a93f7f621ce08.svg";
export { ForwardRef as ReactComponent };